import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import _ from 'lodash';
import React, { Component } from 'react';
import View from "react-native-web/dist/exports/View";
import Text from "react-native-web/dist/exports/Text";
import { xdateToData } from "../../interface";
import XDate from 'xdate';
import dateutils from "../../dateutils";
import styleConstructor from "./style";
import { RESERVATION_DATE } from "../../testIDs";
import { jsx as ___EmotionJSX } from "@emotion/core";

var Reservation = function (_Component) {
  _inherits(Reservation, _Component);

  var _super = _createSuper(Reservation);

  function Reservation(props) {
    var _this;

    _classCallCheck(this, Reservation);

    _this = _super.call(this, props);
    _this.styles = styleConstructor(props.theme);
    return _this;
  }

  _createClass(Reservation, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var r1 = this.props.item;
      var r2 = nextProps.item;
      var changed = true;

      if (!r1 && !r2) {
        changed = false;
      } else if (r1 && r2) {
        if (r1.day.getTime() !== r2.day.getTime()) {
          changed = true;
        } else if (!r1.reservation && !r2.reservation) {
          changed = false;
        } else if (r1.reservation && r2.reservation) {
          if (!r1.date && !r2.date || r1.date && r2.date) {
            if (_.isFunction(this.props.rowHasChanged)) {
              changed = this.props.rowHasChanged(r1.reservation, r2.reservation);
            }
          }
        }
      }

      return changed;
    }
  }, {
    key: "renderDate",
    value: function renderDate(date, item) {
      if (_.isFunction(this.props.renderDay)) {
        return this.props.renderDay(date ? xdateToData(date) : undefined, item);
      }

      var today = dateutils.sameDate(date, XDate()) ? this.styles.today : undefined;

      if (date) {
        return ___EmotionJSX(View, {
          style: this.styles.day,
          testID: RESERVATION_DATE
        }, ___EmotionJSX(Text, {
          allowFontScaling: false,
          style: [this.styles.dayNum, today]
        }, date.getDate()), ___EmotionJSX(Text, {
          allowFontScaling: false,
          style: [this.styles.dayText, today]
        }, XDate.locales[XDate.defaultLocale].dayNamesShort[date.getDay()]));
      } else {
        return ___EmotionJSX(View, {
          style: this.styles.day
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$item = this.props.item,
          reservation = _this$props$item.reservation,
          date = _this$props$item.date;
      var content;

      if (reservation) {
        var firstItem = date ? true : false;

        if (_.isFunction(this.props.renderItem)) {
          content = this.props.renderItem(reservation, firstItem);
        }
      } else if (_.isFunction(this.props.renderEmptyDate)) {
        content = this.props.renderEmptyDate(date);
      }

      return ___EmotionJSX(View, {
        style: this.styles.container
      }, this.renderDate(date, reservation), ___EmotionJSX(View, {
        style: {
          flex: 1
        }
      }, content));
    }
  }]);

  return Reservation;
}(Component);

_defineProperty(Reservation, "displayName", 'IGNORE');

export default Reservation;

if (typeof Reservation !== 'undefined' && Reservation && Reservation === Object(Reservation) && Object.isExtensible(Reservation) && !Reservation.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Reservation, '__filemeta', {
    configurable: true,
    value: {
      name: "Reservation",
      filename: "node_modules/react-native-calendars/src/agenda/reservation-list/reservation.js"
    }
  });
}